"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const checkbox_style_1 = require("./checkbox.style");
require("./checkbox.types");
exports.Checkbox = (0, react_1.memo)((0, react_1.forwardRef)((_a, ref) => {
    var _b;
    var { label, message, status, variant = 'default', className, hasTooltip, tooltipOptions, sizeType = 'm' } = _a, props = __rest(_a, ["label", "message", "status", "variant", "className", "hasTooltip", "tooltipOptions", "sizeType"]);
    const theme = (0, theme_1.useTheme)();
    const checkboxId = (0, uuid_1.v4)();
    return (react_1.default.createElement(checkbox_style_1.Wrapper, { className: className, "data-component": "checkbox" },
        react_1.default.createElement(checkbox_style_1.ControlWrapper, null,
            react_1.default.createElement(checkbox_style_1.NativeCheckbox, Object.assign({}, props, { type: "checkbox", ref: ref, id: checkboxId })),
            react_1.default.createElement(checkbox_style_1.Checkbox, { htmlFor: checkboxId, variant: variant, status: status, sizeType: sizeType },
                react_1.default.createElement(react_1.Suspense, { fallback: null },
                    react_1.default.createElement(checkbox_style_1.IconCheck, { viewBox: "0 0 13 11", width: sizeType === 'm' ? 12 : 8, color: ((_b = theme.common) === null || _b === void 0 ? void 0 : _b.outlined)
                            ? theme.colors.surface.brand
                            : theme.colors['on-accent'].primary }))),
            react_1.default.createElement(checkbox_style_1.Label, { htmlFor: checkboxId, sizeType: sizeType }, label),
            hasTooltip && (react_1.default.createElement(checkbox_style_1.StyledTooltip, { trigger: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.trigger, direction: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.direction, tooltipLabel: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.tooltipLabel, tooltipText: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.tooltipText, tooltipBgColor: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.tooltipBgColor }))),
        message && (react_1.default.createElement(checkbox_style_1.StyledMessage, { sizeType: sizeType, status: status }, message))));
}));
